import { Link, usePage } from "@inertiajs/react";
import { useMediaQuery } from "@uidotdev/usehooks";
import { HousePlus } from "lucide-react";
import type * as React from "react";
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { IS_TABLET_MEDIA_QUERY } from "@/lib/constants";
import { cn } from "@/lib/utils";
import type { GlobalPageProps } from "@/types/globals";
import { NavMain } from "./nav-main";
import { NavUser } from "./nav-user";

export default function AppSidebar({
	...props
}: React.ComponentProps<typeof Sidebar>) {
	const { props: globalProps } = usePage<GlobalPageProps>();
	const isMobile = useIsMobile();
	const isTablet = useMediaQuery(IS_TABLET_MEDIA_QUERY);

	return (
		<Sidebar
			variant="inset"
			collapsible={isMobile || isTablet ? "offcanvas" : "icon"}
			{...props}
		>
			<SidebarHeader
				className={cn(
					"motion-preset-bounce transition-all duration-150 ease-in-out transform-gpu",
					globalProps.adminPortal.railsEnv !== "production" ? "pt-8" : "pt-0",
				)}
			>
				<SidebarMenu>
					<SidebarMenuItem>
						<SidebarMenuButton size="lg" asChild>
							<Link href={globalProps.adminPortal.router.authenticatedRootPath}>
								<div className="flex items-center justify-center rounded-lg bg-primary aspect-square size-8 text-sidebar-primary-foreground">
									<HousePlus className="size-4" />
								</div>
								<div className="grid flex-1 text-sm leading-tight text-left">
									<span className="font-bold uppercase truncate">
										Fisiohome
									</span>
									<span className="text-xs uppercase truncate">
										Admin Portal
									</span>
								</div>
							</Link>
						</SidebarMenuButton>
					</SidebarMenuItem>
				</SidebarMenu>
			</SidebarHeader>

			<SidebarContent>
				<NavMain />
			</SidebarContent>

			<SidebarFooter className="motion-preset-bounce">
				<NavUser />
			</SidebarFooter>
		</Sidebar>
	);
}
